export default __webpack_public_path__ + "static/media/Appnovation.a0ec424a.png";